import {
  COPY_LANDING_PAGE_ASYNC,
  DELETE_LANDING_PAGE_ASYNC,
  LANDING_PAGES_REQUEST_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
  SEARCH_RESET,
} from './constants'

export const fetchLandingPages = () => ({
  type: LANDING_PAGES_REQUEST_ASYNC.INITIATE,
})
export const fetchLandingPagesSuccess = (data) => ({
  type: LANDING_PAGES_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
const fetchLandingPagesCancel = () => ({
  type: LANDING_PAGES_REQUEST_ASYNC.CANCEL,
})
export const fetchLandingPagesError = (error) => ({
  type: LANDING_PAGES_REQUEST_ASYNC.ERROR,
  error,
})

const paginateChange = (page) => ({ type: PAGINATE_CHANGE, payload: { page } })
const searchChange = (q) => ({ type: SEARCH_CHANGE, payload: { q } })
const searchReset = () => ({ type: SEARCH_RESET })

export const deleteLandingPage = (id) => ({
  type: DELETE_LANDING_PAGE_ASYNC.INITIATE,
  payload: { id },
})
export const deleteLandingPageSuccess = () => ({
  type: DELETE_LANDING_PAGE_ASYNC.SUCCESS,
})
export const deleteLandingPageError = (error) => ({
  type: DELETE_LANDING_PAGE_ASYNC.ERROR,
  error,
})

export const copyLandingPage = (id, companiesIds) => ({
  type: COPY_LANDING_PAGE_ASYNC.INITIATE,
  payload: { id, companiesIds },
})
export const copyLandingPageSuccess = () => ({
  type: COPY_LANDING_PAGE_ASYNC.SUCCESS,
})
export const copyLandingPageError = (error) => ({
  type: COPY_LANDING_PAGE_ASYNC.ERROR,
  error,
})

export default {
  // to props
  fetchLandingPages,
  fetchLandingPagesCancel,
  paginateChange,
  searchChange,
  searchReset,
  deleteLandingPage,
}
